const RECOVERY_SESSION_KEY = 'memberNest.firestoreAssertionRecoveryAt';
const RECOVERY_THROTTLE_MS = 2 * 60 * 1000;
const DEFAULT_RECOVERY_RELOAD_DELAY_MS = 1200;

export const FIRESTORE_ASSERTION_RECOVERY_MESSAGE =
  'Member Nest hit a temporary browser sync issue. Refreshing should clear it.';

let firestoreRecoveryReloadScheduled = false;

const FIRESTORE_UNEXPECTED_STATE_PATTERN =
  /FIRESTORE \((?:11|12)\.\d+\.\d+\) INTERNAL ASSERTION FAILED: (?:Unexpected state \(ID: (?:ca9|b815|c050|da08)\)|(?:ca9|b815|c050|da08):)/;

function getMessage(error) {
  if (error instanceof Error) return error.message || '';
  if (error && typeof error === 'object') {
    return String(error.message || error.reason || '');
  }
  return String(error || '');
}

function getStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage || null;
  } catch (err) {
    return null;
  }
}

export function isRecoverableFirestoreAssertion(error) {
  return FIRESTORE_UNEXPECTED_STATE_PATTERN.test(getMessage(error));
}

export function canReloadForFirestoreAssertion(now = Date.now(), storage = getStorage()) {
  if (!storage) return true;
  const previous = Number(storage.getItem(RECOVERY_SESSION_KEY) || 0);
  return !previous || now - previous > RECOVERY_THROTTLE_MS;
}

export function markFirestoreAssertionReload(now = Date.now(), storage = getStorage()) {
  if (!storage) return;
  try {
    storage.setItem(RECOVERY_SESSION_KEY, String(now));
  } catch (err) {
    // Ignore storage failures; the recovery reload is still useful.
  }
}

export function scheduleFirestoreAssertionRecoveryReload({
  delayMs = DEFAULT_RECOVERY_RELOAD_DELAY_MS,
  now = Date.now(),
  storage = getStorage(),
} = {}) {
  if (firestoreRecoveryReloadScheduled || typeof window === 'undefined') return false;
  if (!canReloadForFirestoreAssertion(now, storage)) return false;

  firestoreRecoveryReloadScheduled = true;
  markFirestoreAssertionReload(now, storage);
  window.setTimeout(() => {
    window.location.reload();
  }, delayMs);
  return true;
}

export function getFirestoreAssertionRecoveryMessage(error, fallback = 'Please refresh and try again.') {
  if (isRecoverableFirestoreAssertion(error)) {
    scheduleFirestoreAssertionRecoveryReload();
    return FIRESTORE_ASSERTION_RECOVERY_MESSAGE;
  }

  return getMessage(error) || fallback;
}
